module.exports = __webpack_public_path__ + "fonts/rozoviichulok_regular.527852f.woff2";